import React, { useState, useEffect, useCallback } from 'react';
import { BiometricGate } from '@nbx/ui-components';
import { navigateToUrl } from 'single-spa';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { useBiometricGate } from '@nbx/frontend-helpers/auth';

// eslint-disable-next-line no-console
const log = (...args: unknown[]) => console.log('<MobileSessionExpired>', ...args);
const microapps = window.MICROFRONTENDS_CONFIG;

export const MobileSessionExpired = props => {
  const [isAppActive, setIsAppActive] = useState<boolean>();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>();

  useEffect(() => {
    log(`props.location ${JSON.stringify(props.location)}`);
    log(
      `props.location?.state?.from?.state?.from?.pathname - ${props.location?.state?.from?.state?.from?.pathname}`
    );
  }, [props.location]);

  useEffect(() => {
    log(`mount`);
    App.getState().then(({ isActive }) => {
      log(`App.getState() isActive=${isActive}`);
      setIsAppActive(isActive);
    });
    return () => log(`dismount`);
  }, []);

  const updateIsActive = useCallback(() => {
    App.getState().then(({ isActive }) => {
      log(`applicationDidBecomeActive - updateIsActive: App.getState() isActive=${isActive}`);
      setIsAppActive(isActive);
    });
  }, []);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      window.addEventListener('applicationDidBecomeActive', updateIsActive);
      return () => {
        window.removeEventListener('applicationDidBecomeActive', updateIsActive);
      };
    }
  }, [updateIsActive]);

  const { authenticate, refreshTokens, loading, error } = useBiometricGate({
    tag: 'login',
    showWhenNoSession: true,
    onSuccess: async session => {
      log(`onRequestBiometricAuth done (session=${session?.exp})`);
      await refreshTokens(session);
      setIsAuthenticated(true);
    }
  });

  const handleBiometricRequest = useCallback(() => {
    setIsAuthenticated(false);
    authenticate();
  }, [authenticate]);

  useEffect(() => {
    if (!isAuthenticated || props.loading || props.error) return;
    log(
      `navigateToUrl ${
        props.location?.state?.from?.state?.from?.pathname ?? microapps?.routes?.dashboards?.path
      }`
    );
    navigateToUrl(props.location?.state?.from?.state?.from?.pathname ?? microapps?.routes?.dashboards?.path);
  }, [isAuthenticated, props.location?.state?.from?.state?.from?.pathname, props.loading, props.error]);

  return (
    <BiometricGate
      onRequestBiometricAuth={handleBiometricRequest}
      loading={!props.error && (props.loading || loading || isAuthenticated === false)}
      error={props.error || error}
      requestOnInit={!!isAppActive && !isAuthenticated}
      tag="login"
    />
  );
};
